export const numSx = {
    fontVariantNumeric: 'tabular-nums',
} as const;

export const TEXT_SIZE = {
    caption: '10px',
    label: '11px',
    body: '12px',
    title: '13px',
    figure: '15px',
    page: '18px',
} as const;
